import './styles.scss';

import 'babel-polyfill';
import 'bootstrap/dist/js/bootstrap';
import Rails from 'rails-ujs';
import Vue from 'vue/dist/vue.esm.js';
import BootstrapVue from 'bootstrap-vue';
import ActionCableVue from 'actioncable-vue';
import VueI18n from 'vue-i18n';
import { messages } from '../src/i18n.js';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { initShareButtons } from '../src/front/js/share_button';
import { connectCableImmediately } from '../src/front/js/public_results_cable_policy';

import CombinedResults from '../src/front/components/combined-results';
import CompareButton from '../src/front/components/compare-button';
import DateTime from '../src/admin/components/datetime';
import EventResultsStatistics from '../src/front/components/event-results-statistics';
import EventsList from '../src/front/components/events-list';
import GCTable from '../src/front/components/gc-table';
import GenderIcon from '../src/front/components/gender-icon';
import HeatPhotos from '../src/front/components/heat-photos.vue';
import HeatsTable from '../src/front/components/heats-table';
import HeatsTableSimple from '../src/front/components/heats-table-simple';
import LiveResults from '../src/front/components/live-results';
import PointsCalculator from '../src/front/components/points-calculator';
import RemoveFromComparisonButton from '../src/front/components/remove-from-comparison-button';
import ResultsTable from '../src/front/components/results-table';
import Rotator from '../src/front/components/rotator';
import SearchForm from '../src/admin/components/search-form';
import ToggleComparisonButton from '../src/front/components/toggle-comparison-button';

Vue.config.productionTip = false;
Rails.start();
Vue.use(BootstrapVue);

const currentOriginCableUrl = () => {
  if (typeof window !== 'undefined' && window.location) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/cable`;
  }

  return process.env.CABLE_URL;
};

const metaCableUrl = () => {
  if (typeof document === 'undefined') return null;

  const element = document.head.querySelector("meta[name='action-cable-url']");
  return element?.getAttribute('content');
};

const cableConnectionUrl = () => metaCableUrl() || currentOriginCableUrl() || process.env.CABLE_URL;

Vue.use(ActionCableVue, {
  debug: false,
  debugLevel: 'all',
  connectionUrl: cableConnectionUrl(),
  // Only RacesController#show defers the socket until its configured live window.
  connectImmediately: connectCableImmediately(document)
});
Vue.use(VueI18n);
Vue.use(VueAxios, axios);

Vue.axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
Vue.axios.defaults.headers.common.Accept = 'application/json';
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';

$(() => {
  window.i18n = new VueI18n({ locale: window.general.locale, messages });

  const element = document.getElementById('app');
  if (element) {
    window.app = new Vue({
      el: element,
      i18n: window.i18n,
      data() {
        return {
          heats: window.general.heats || [],
          race: window.general.race || {},
          event: window.general.event || {},
          slug: window.general.slug || '',
          event_results_statistics: window.general.event_results_statistics || {},
          loading: false,
          searchEmpty: false,
          extra: window.general.extra || {}
        };
      },
      components: {
        'combined-results': CombinedResults,
        'compare-button': CompareButton,
        datetime: DateTime,
        'event-results-statistics': EventResultsStatistics,
        'events-list': EventsList,
        'gc-table': GCTable,
        'gender-icon': GenderIcon,
        'heats-table': HeatsTable,
        'heat-photos': HeatPhotos,
        'heats-table-simple': HeatsTableSimple,
        'live-results': LiveResults,
        'points-calculator': PointsCalculator,
        'remove-from-comparison-button': RemoveFromComparisonButton,
        'results-table': ResultsTable,
        rotator: Rotator,
        'search-form': SearchForm,
        'toggle-comparison-button': ToggleComparisonButton
      }
    });
  }

  initShareButtons();
});
